import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateVideoPostMutation = createMutationHook(
  MembershipsCreatorApiClient.updateVideoPost,
  {
    mutationKey: ['updateVideoPost'],
  },
)
